import React from 'react'
import { t } from '../../i18n.js'

// Progress indicator showing completion status of four steps.
// `translations` is the new_valuation.progress subtree from Rails.
export default function ProgressIndicator({ clientName, fundName, hasAssets, valuationDate, translations }) {
  // Determine step states
  const clientCompleted = !!clientName
  const fundCompleted = !!fundName
  const dateCompleted = !!valuationDate
  const assetsCompleted = hasAssets

  // Determine current step (first incomplete step)
  let currentStep = 1
  if (clientCompleted && !fundCompleted) currentStep = 2
  else if (clientCompleted && fundCompleted && !dateCompleted) currentStep = 3
  else if (clientCompleted && fundCompleted && dateCompleted && !assetsCompleted) currentStep = 4
  else if (clientCompleted && fundCompleted && dateCompleted && assetsCompleted) currentStep = 5 // All completed

  // Helper function to get step class
  const getStepClass = (stepNumber) => {
    if (stepNumber < currentStep) return 'progress-step completed'
    if (stepNumber === currentStep) return 'progress-step current'
    return 'progress-step future'
  }

  // Helper function to get icon
  const getIcon = (stepNumber) => {
    if (stepNumber < currentStep) {
      return <i className="bi bi-check-circle-fill"></i>
    }
    return <i className="bi bi-arrow-right-circle"></i>
  }

  // Helper function to get text
  const getStepText = (stepNumber) => {
    switch (stepNumber) {
      case 1:
        return clientCompleted
          ? t('step_client_completed', translations, { name: clientName })
          : t('step_client_pending', translations)
      case 2:
        return fundCompleted
          ? t('step_fund_completed', translations, { name: fundName })
          : t('step_fund_pending', translations)
      case 3:
        return dateCompleted
          ? t('step_date_completed', translations)
          : t('step_date_pending', translations)
      case 4:
        return assetsCompleted
          ? t('step_assets_completed', translations)
          : t('step_assets_pending', translations)
      default:
        return ''
    }
  }

  return (
    <div>
      <div className={getStepClass(1)}>
        {getIcon(1)}
        <span>{getStepText(1)}</span>
      </div>

      <div className={getStepClass(2)}>
        {getIcon(2)}
        <span>{getStepText(2)}</span>
      </div>

      <div className={getStepClass(3)}>
        {getIcon(3)}
        <span>{getStepText(3)}</span>
      </div>

      <div className={getStepClass(4)}>
        {getIcon(4)}
        <span>{getStepText(4)}</span>
      </div>
    </div>
  )
}
